import React from 'react'
import Branding from './Branding'
import PageSection from './PageSection'
import Compliance from './Compliance'
import Booking from './Booking'
import Footer from './Footer'
import Clients from './Clients'

import { MdPermPhoneMsg } from "react-icons/md";
import {  FaPhoneAlt, FaDesktop, FaGlobe, FaPhoneSquareAlt, FaMobileAlt, FaChartBar, FaAndroid, FaSmile,  } from "react-icons/fa";

import fd from '../../ContactImage/frontdesk.jpg';
import om from '../../ContactImage/omnichannelccm.png';
import vo from '../../ContactImage/voip.png';
import bp from '../../ContactImage/Businessphone.png';
import vs from '../../ContactImage/virtualassistant.jpeg';
import ci from '../../ContactImage/aicsat.png';
import is from '../../Assets/phones.png';
import mc from '../../ContactImage/monitorcalls.png';
import fs from '../../ContactImage/callsoverview.jpeg';
import { useNavigate } from 'react-router-dom'





function Contactcenter() {
  const navigate = useNavigate();
  const monitorBusinessCallsData = [
    {
      icon: <FaPhoneAlt />,
      image: mc,
      iconTitle: 'Monitor Business Calls',
      title: 'Efficiently monitor and analyze business calls for improved customer service.',
      lines: [
        'Real-time monitoring of inbound and outbound business calls.',
        'Analyze call data to identify areas for improvement.',
        'Enhance customer interactions and satisfaction with call insights.'
      ],
    },
  ];
  const frontDeskManagementData = [
    {
      icon:<FaDesktop /> ,
      iconTitle: 'Front Desk Management',
      image: fd,
      title: 'Streamline front desk operations for a seamless and organized customer experience.',
      lines: [
        'Efficiently manage customer inquiries and appointments.',
        'Coordinate front desk activities for optimal customer service.',
        'Enhance the overall customer experience with organized front desk management.'
      ],
    },
  ];
  const omnichannelData = [
    {
      icon: <FaGlobe />,
      iconTitle: 'Omnichannel',
      image: om,
      title: 'Provide a unified and consistent customer experience across multiple channels.',
      lines: [
        'Seamlessly integrate communication channels for a unified view.',
        'Ensure consistent service and information regardless of the channel.',
        'Optimize omnichannel strategies for enhanced customer satisfaction.'
      ],
    },
  ];

  const voipData = [
    {
      icon: <FaPhoneSquareAlt />,
      iconTitle: 'VoIP',
      image: vo,
      title: 'Leverage Voice over Internet Protocol for efficient and cost-effective communication.',
      lines: [
        'Make voice calls over the internet for reduced costs.',
        'Enhance call quality and reliability with VoIP technology.',
        'Integrate VoIP seamlessly into your contact center operations.'
      ],
    },
  ];
  
  const businessPhoneData = [
    {
      icon: <FaMobileAlt />,
      iconTitle: 'Business Phone',
      image: bp,
      title: 'Equip your business with dedicated phone lines for professional and efficient communication.',
      lines: [
        'Provide dedicated phone numbers for customer inquiries.',
        'Manage and track business calls for improved responsiveness.',
        'Enhance business professionalism with a dedicated business phone.'
      ],
    },
  ];
  const interactionAnalysisData = [
    {
      icon: <FaChartBar />,
      iconTitle: 'Interaction Analysis',
      image: is,
      title: 'Analyze customer interactions to gain insights and improve contact center performance.',
      lines: [
        'Monitor and analyze customer interactions for data-driven insights.',
        'Identify patterns and trends in customer communication.',
        'Optimize strategies based on interaction analysis for better customer service.'
      ],
    },
  ];
  const virtualAssistantData = [
    {
      icon: <FaAndroid />,
      iconTitle: 'Virtual Assistant',
      image: vs,
      title: 'Implement AI-powered virtual assistants for efficient and automated customer support.',
      lines: [
        'Automate routine tasks and inquiries with virtual assistant technology.',
        'Enhance customer service with 24/7 availability and instant responses.',
        'Improve efficiency and streamline contact center operations with virtual assistants.'
      ],
    },
  ];
  const aiCSATData = [
    {
      icon: <FaSmile />,
      iconTitle: 'AI CSAT',
      image: ci,
      title: 'Utilize AI for Customer Satisfaction (CSAT) analysis to measure and enhance customer happiness.',
      lines: [
        'Implement AI algorithms to analyze customer satisfaction levels.',
        'Gather insights from customer feedback for continuous improvement.',
        'Enhance customer experiences and satisfaction with AI-driven CSAT analysis.'
      ],
    },
  ];
  
  
  
  
  return (
    <div className='pt-5  gap-[70px] flex flex-col items-center min-h-full w-full'>
    <div className='w-full flex justify-center bg-white sticky top-0 pt-5'>
        <div   className={` w-[78%]   flex  bg-white  pb-4 `}>    
            <div className='flex gap-2 items-center'>
                <div>
                <MdPermPhoneMsg className='text-[30px] text-blue-600' />
                </div>
                <div className='flex flex-col'>
                    <span className='semibold text-[13px]'>Elyzian</span>
                    <span className='bold text-sm'>Contact Center Management</span>

                </div>
            </div>
        </div>
  </div>

  {/* 1st Section */}

  <div   className="w-full sm:w-[90%] lg:w-[85%] 2xl:w-[78%] h-max lg:h-[620px] sm:mt-3  flex flex-col lg:flex-row gap-6 lg:gap-3   p-[5%] bg-[#fafafa] sm:rounded-[50px]">       
     <div className='w-full lg:w-[50%] flex flex-col gap-5 justify-start h-full'>
        <div>     
        <span className='bold text-[28px] lg:text-[32px] xl:text-[38px] 2xl:text-[44px]   sm:leading-[45px] xl:leading-[55px] 2xl:leading-[65px]'>From Calls to Delight: Revolutionizing Customer Interactions</span>    
</div>
       
        <span className='regular  text-sm sm:text-base lg:text-[18px] 2xl:text-[20px] leading-[26px] lg:leading-[36px]  '> Monitor business calls in real-time, streamline front desk operations, and provide a unified omnichannel experience.  Transform conversations, elevate satisfaction, and deliver exceptional customer experiences with the art of Contact Center Management.
        </span>
        
            
            <button onClick={() => navigate('/waitlist')} className="flex items-center gap-2 text-sm w-max  sm:text-[14px]  tracking-wide rounded-lg hover:shadow hover:bg-[#1e46f6f6] hover:ring-[2px] hover:ring-blue-200 bold px-3 py-2 sm:px-5 border sm:p-[12px] bg-[#1e47f6] border-[#1e47f6] text-white hover:transition hover:delay-200">
<span className="button-content medium">Get Started Free</span>
</button>
     </div>
     <div className='  w-full lg:w-[50%]'>
     <img className=' aspect-auto rounded-2xl' src={fs} alt="" />
     </div>
  </div>

  {/* 2nd Section */}
        <Clients />

    
  {/* 4th Section */}
  <PageSection bg  data={monitorBusinessCallsData} />

  <PageSection reverse  data={frontDeskManagementData} />
  {/* <Clients /> */}


  <PageSection   data={omnichannelData} />

  <PageSection bg  data={voipData} />

  <PageSection reverse  data={businessPhoneData} />

  <PageSection   data={interactionAnalysisData} />

  <PageSection reverse bg  data={virtualAssistantData} />

  <PageSection   data={aiCSATData} />




  <Branding />





  <Compliance />

  <Booking />

  <Footer />






</div>
  )
}

export default Contactcenter
